let id = 1;
let fakeId = 1;

export default {
  id: () => id++,
  fakeId: () => `f_${fakeId++}`,
  hasRealId: item => Number.isInteger(item.itemid),
};
